<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="stage-page-header">
            <div class="stage-page-header-row">
                <div class="stage-page-header-main">
                    <div class="flex flex-wrap items-center gap-2">
                        <h1 class="stage-page-title">Insights</h1>
                        <div class="stage-shortcut-badges">
                            <span
                                v-for="badge in $navigationShortcutBadges('insights')"
                                :key="badge.key"
                                :title="badge.title || 'Shortcut'"
                                class="stage-shortcut-badge"
                            >
                                <svg-vue class="stage-shortcut-badge-icon" icon="font-awesome.solid.command"></svg-vue>
                                {{ badge.label }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="stage-page-body stage-page-fill">
            <div class="w-full h-full bg-white shadow sm:rounded relative overflow-hidden flex flex-col min-h-0">
                <div class="relative flex-1 min-h-0 overflow-hidden">
                    <div class="h-full overflow-auto">
                        <div class="hidden sm:block">
                            <div class="align-middle inline-block min-w-full border-b border-ultralight">
                                <table class="table-listview table-listview--zebra">
                                    <thead>
                                    <tr>
                                        <th class="table-listview-l-th">Name</th>
                                        <th class="table-listview-l-th">Description</th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white">
                                    <tr
                                        v-for="service in visibleServices"
                                        :key="service.route"
                                        class="cursor-pointer"
                                        @click="$router.push(service.route)"
                                    >
                                        <td class="table-listview-l-td whitespace-no-wrap">
                                            <div class="flex items-center">
                                                <div class="flex-shrink-0 rounded-full bg-gray-700 mr-3">
                                                    <svg-vue class="w-8 h-8 p-1.5 text-gray-200" :icon="service.icon"></svg-vue>
                                                </div>
                                                <div class="text-sm font-medium text-gray-700">
                                                    {{ service.title }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="table-listview-l-td">
                                            <div class="text-sm text-gray-500">{{ service.description }}</div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="sm:hidden p-4 space-y-3">
                            <router-link
                                v-for="service in visibleServices"
                                :key="'mobile-' + service.route"
                                :to="service.route"
                                class="block border border-bordergray-100 rounded p-3 bg-white"
                            >
                                <div class="flex items-center">
                                    <div class="flex-shrink-0 rounded-full bg-gray-700 mr-3">
                                        <svg-vue class="w-8 h-8 p-1.5 text-gray-200" :icon="service.icon"></svg-vue>
                                    </div>
                                    <div class="min-w-0 flex-1">
                                        <div class="text-sm font-medium text-gray-700 truncate">
                                            {{ service.title }}
                                        </div>
                                        <div class="text-xs text-gray-500 mt-1">
                                            {{ service.description }}
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "dashboard-insights-index",
    metaInfo() {
        return {
            title: 'Insights'
        }
    },
    data() {
        return {
            services: [
                {
                    route: '/workspace/insights/server-monitoring',
                    title: 'Server Monitoring',
                    description: 'Infrastructure, server agent, and repository status monitoring.',
                    icon: 'font-awesome.tasks-regular',
                }
            ],
        };
    },
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        isCustomerContext() {
            return this.accessContext.template_family === 'customer';
        },
        visibleServices() {
            if (this.accessContext.is_admin) {
                return this.services;
            }
            if (!this.accessContext.modules.insights) {
                return [];
            }

            return this.services.map((service) => {
                if (!this.isCustomerContext) {
                    return service;
                }

                return {
                    ...service,
                    route: String(service.route || '').replace('/workspace/insights', '/insights')
                };
            });
        }
    }
}
</script>
